<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg1
      .service-container__title {{ $t('营销采购数字化管理') }}
      .service-container__desc {{ $t('为企业定制标准化营销采购流程，推进数字化管理。帮助企业实现采购流程透明合规，营销数据集中管理，降低营销采购成本，平均可为企业节省30%的采购成本。') }}
    .service-content-container
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconfengxian
          .item__title {{ $t('透明性，合规性差') }}
          .item__desc {{ $t('企业缺乏标准的营销采购流程，或缺乏有效的流程管理工具，导致采购流程不透明，合规性差，为企业带来风险。') }}
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconcaigouchengben
          .item__title {{ $t('采购成本高') }}
          .item__desc {{ $t('营销采购流程缺乏透明性会间接导致采购价格不合理。企业缺乏有效的供应商管理机制，也会导致无法筛选到低价优质的供应商，采购成本偏高。') }}
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconshujufensan
          .item__title {{ $t('数据分散') }}
          .item__desc {{ $t('采购流程中涉及到的价格，媒体表现数据等核心数据资源分散在各处，企业无法全面，及时掌握营销投入和产出情况，从而导致无法有效地制定营销计划。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          .solution-content
            .solution-content__title {{ $t('营销流程标准化方案') }}
            .solution-content__desc {{ $t('复歌为多家企业主，广告代理商提供过营销流程数字化服务，拥有丰富的行业经验。复歌将帮助客户梳理现有流程，设计出一套符合企业规范和特征的个性化流程管理及供应商管理解决方案。')}}
            .solution-content__link(
              @click="$router.push('/product/libra')"
            )
              img(src="@/assets/logo-umcc.png")
              span Rimix
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-digital-1.png"
          )
        .solution-item
          .solution-content
            .solution-content__title {{ $t('流程数字化') }}
            .solution-content__desc {{ $t('为企业提供数字化的落地解决方案，将标准化流程实施落地为企业管理平台。以复歌营销采购管理系统Rimix为基础，依据客户需求做定制化开发和实施。') }}
            .solution-content__link(
              @click="$router.push('/product/libra')"
            )
              img(src="@/assets/logo-umcc.png")
              span Rimix
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-digital-2.png"
          )

        .solution-item
          .solution-content
            .solution-content__title {{ $t('培训与推广') }}
            .solution-content__desc {{ $t('协助企业相关部门进行企业内的培训与推广，确保数字化进程顺利推进。')}}
          img(
            src="@/assets/service-digital-3.png"
          )
    mobile-case-sample(
      :data="caseList"
    )
    mobile-contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
import MobileCaseSample from '@/components/MobileCaseSample'

export default {
  components: {
    MobileContact,
    MobileCaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/umcc',
          img: require('@/assets/case-umcc.png'),
          title: '联合利华',
          desc: '联合利华营销采购管理平台，收集并整合数据，提供高效的决策建议。'
        }
      ]
    }
  }
}
</script>
